import CryptoJS from "crypto-js";

const SECRET_KEY = "hrglobes!@#$%^&*";

const toUrlSafe = (str) =>
  str.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");

const fromUrlSafe = (str) => {
  let base64 = str.replace(/-/g, "+").replace(/_/g, "/");
  while (base64.length % 4) {
    base64 += "=";
  }
  return base64;
};

export const encrypt = (data) => {
  if (!data) return null;
  const encrypted = CryptoJS.AES.encrypt(
    data.toString(),
    SECRET_KEY
  ).toString();
  return toUrlSafe(encrypted);
};

export const decrypt = (urlSafeCipher) => {
  try {
    const base64Cipher = fromUrlSafe(urlSafeCipher);
    const bytes = CryptoJS.AES.decrypt(base64Cipher, SECRET_KEY);
    if (!bytes.toString(CryptoJS.enc.Utf8)) {
      window.location.href = "/error-404";
      return null;
    }
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Decryption failed:", error);
    window.location.href = "/error-404";
    return null;
  }
};
